if (!window.customElements.get('site-carousel')) {
/*
Carousel Prev
*/

  class CarouselPrev extends HTMLElement {
    constructor () {
      super()
      this.carousel = this.closest('site-carousel')
    }

    connectedCallback () {
      if (!this.carousel) {
        console.error('<carousel-prev> needs to be a child of <site-carousel>')
      }
      if (!this.querySelector('button')) {
        console.warn('You need to have a child button to go to previous!')
      }
      this.addEventListener('click', (e) => {
        this.carousel.previous()
      })
    }
  }

  customElements.define('carousel-prev', CarouselPrev)

  /*
Carousel Next
*/

  class CarouselNext extends HTMLElement {
    constructor () {
      super()
      this.carousel = this.closest('site-carousel')
    }

    connectedCallback () {
      if (!this.carousel) {
        console.error('<carousel-next> needs to be a child of <site-carousel>')
      }
      if (!this.querySelector('button')) {
        console.warn('You need to have a child button to go to next!')
      }
      this.addEventListener('click', (e) => {
        this.carousel.next()
      })
    }
  }

  customElements.define('carousel-next', CarouselNext)

  /*
Carousel Pager
*/

  class CarouselPager extends HTMLElement {
    constructor () {
      super()
      this.swiper = null
    }

    connectedCallback () {
      const pagerButtons = Array.from(this.querySelectorAll('button'))

      if (!pagerButtons.length > 1) {
        console.warn('No need for a pager with only one item!')
      }

      pagerButtons.forEach((pager, i) => {
        pager.addEventListener('click', (e) => {
          const carousel = e.target.closest('site-carousel')

          pagerButtons.forEach((button) => {
            button.classList.remove('active')
          })

          if (carousel) {
            carousel.slideTo(i)
          } else {
            console.error('<carousel-pager> needs to be a child of <site-carousel>')
          }
        })
      })
    }
  }

  customElements.define('carousel-pager', CarouselPager)

  /*
 * Site Carousel
 */

  class SiteCarousel extends HTMLElement {
    constructor () {
      super()
      this.swiper = null
    }

    connectedCallback () {
      const defaultConfig = {
        simulateTouch: true,
        allowTouchMove: true,
        grabCursor: true,
      }
      const baseConfig = this.dataset.config ? JSON.parse(this.dataset.config) : { slidesPerView: 3, spaceBetween: 20 }
      const config = { ...baseConfig, ...defaultConfig }

      const slider = this.querySelector('.swiper')
      this.swiper = new Swiper(slider, config)

      // Handle nested swiper scrolling
      const parentSwiper = this.closest('.swiper')
      if (parentSwiper) {
        this.addEventListener('wheel', (e) => {
          e.stopPropagation()
        }, { passive: false })
      }

      this.fadeVideosCarouselEffect()

      this.handleSlideChange()
      this.refreshButtons()
    }

    fadeVideosCarouselEffect () {
      if (this.classList.contains('opacity-0')) {
        this.classList.remove('opacity-0')
      }
    }

    previous () {
      if (this.swiper) {
        this.swiper.slidePrev()
      }
    }

    next () {
      if (this.swiper) {
        this.swiper.slideNext()
      }
    }

    slideTo (i) {
      if (this.swiper) {
        this.swiper.slideTo(i)
      }
    }

    scrollToBullet (button) {
      if (button.dataset.disableScroll) return
      button.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center',
      })
    }

    handleSlideChange () {
    // we can have multiple pagers in one carousel
      const pagers = Array.from(this.querySelectorAll('carousel-pager'))

      if (this.swiper) {
        console.log('this.id', this.swiper)
        this.swiper.on('slideChange', () => {
          const formatTwoDigits = (number) => (number < 10 ? `0${number}` : number)

          const carouselIndexEl = this.querySelector('.carousel-index')
          if (carouselIndexEl && carouselIndexEl.dataset.disableZero) {
            carouselIndexEl.innerHTML = this.swiper.realIndex + 1
          } else if (carouselIndexEl) {
            carouselIndexEl.innerHTML = formatTwoDigits(this.swiper.realIndex + 1)
          }

          pagers.forEach((pager) => {
            const bullets = this.querySelectorAll('.carousel-bullet')
            const defaultBullets = this.querySelectorAll('.swiper-pagination-bullet')
            const buttons = pager.querySelectorAll('button')
            const nextPager = bullets[this.swiper.realIndex]
            const bulletsName = pager.querySelectorAll('p')
            const nextBulletName = bulletsName[this.swiper.realIndex]

            if (defaultBullets && defaultBullets.length > 0) {
              defaultBullets.forEach((bullet) => {
                bullet.classList.remove('swiper-pagination-bullet-active')
                defaultBullets[this.swiper.realIndex].classList.add('swiper-pagination-bullet-active')
              })
              return
            }

            bullets.forEach((bullet) => bullet.classList.remove('active'))
            bulletsName.forEach((bulletName) => bulletName.classList.remove('active'))
            buttons.forEach((button) => button.addEventListener('click', () => this.scrollToBullet(button)))

            nextPager?.classList.add('active')
            nextBulletName && nextBulletName.classList.add('active')

            this.scrollToBullet(buttons[this.swiper.realIndex])
          })

          this.pauseAllVideos()

          this.dispatchEvent(
            new CustomEvent('slideChange', {
              detail: { index: this.swiper.realIndex },
            }),
          )
          this.refreshButtons()
        })
      }
    }

    refreshButtons () {
      const carouselNext = this.querySelector('carousel-next')
      const carouselPrev = this.querySelector('carousel-prev')
      if (carouselNext) {
        carouselNext.classList.add('is-active')
        if (this.swiper.isEnd) {
          carouselNext.classList.remove('is-active')
        }
      }
      if (carouselPrev) {
        carouselPrev.classList.add('is-active')
        if (this.swiper.isBeginning) {
          carouselPrev.classList.remove('is-active')
        }
      }
    }

    refresh () {
      console.log('refresh')
      this.swiper.update()
    }

    pauseAllVideos () {
      const videos = this.querySelectorAll('video')
      videos.forEach((video) => {
        video.pause()
      })
    }
  }

  customElements.define('site-carousel', SiteCarousel)
}
